import type { BaseKeyFunction } from "../../../lib";

export const keyCart: BaseKeyFunction = () => ["cart"];
